/**
 * Global API file for all API calls
 */
import axios from 'axios';
import http, { httpWithoutHeaders } from './api';

export const getOtp = async (data) =>
  httpWithoutHeaders.post(`/enduser/login/`, data);

export const verifyOtp = async (data) =>
  await httpWithoutHeaders.post(`/login/`, data);

export const getOrders = async (page) =>
  http.get(`/payment/order?type=ecommerce&status=COMPLETED&page=${page}`);

export const getTransactionDetail = async (txn_id, redeem) =>
  await httpWithoutHeaders.get(
    `/payment/order/${txn_id}/?type=ecommerce&redeem=${redeem}`
  );

export const getAuthenticatedTransactionDetail = async (txn_id) =>
  await http.get(`/payment/order/${txn_id}/`);

export const getAllBanks = async () => http.get(`/payment/institution/`);

export const verifyBankDetails = async (data) =>
  http.post(`/payment/bank-link/authorize/`, data);

export const verifyBankAuthToken = async (data) =>
  http.post(`/payment/verify-redirect-token/`, data);

export const getEndUserDetails = async (end_user_id) =>
  http.get(`/enduser/${end_user_id}/`);

export const setDefaultBank = async (end_user_id, data) =>
  http.put(`/payment/bank-link/${end_user_id}/`, data);

export const updateBankDetails = async (data) =>
  http.put(`/enduser/update-bank-details/`, data);
